export default __webpack_public_path__ + "static/media/front_bcr.eb383930.svg";